export default __webpack_public_path__ + "static/media/computador&Cafe.e684e6d0.svg";